import { useState } from "react";
import { Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { adminLogin, setToken, apiError } from "@/lib/admin";

export default function AdminLogin({ onSuccess }) {
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError("");
        try {
            setToken(await adminLogin(password));
            onSuccess();
        } catch (err) {
            setError(apiError(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-[#3D2318] px-4" data-testid="admin-login">
            <form onSubmit={submit} className="w-full max-w-sm rounded-[2rem] bg-[#FFFDF9] p-8 sm:p-10 shadow-[0_30px_80px_rgba(0,0,0,0.35)]">
                <Link to="/" className="flex items-center gap-3" data-testid="admin-login-logo">
                    <img src="/annabells-logo.png" alt="Annabells Cupcakes and More" className="h-12 w-12 rounded-full object-cover ring-2 ring-[#D4AF37]/50" />
                    <span className="leading-none">
                        <span className="font-script text-2xl text-[#C95B7D] block">Annabells</span>
                        <span className="text-[10px] tracking-[0.3em] uppercase text-[#8C6A5D] font-semibold">Order Inbox</span>
                    </span>
                </Link>
                <h1 className="mt-8 font-display text-2xl font-bold text-[#3D2318]">Welcome back, Annabell</h1>
                <p className="mt-1 text-sm text-[#6B4A3E]">Enter your password to see order requests.</p>
                <label className="mt-6 block text-[10px] font-bold uppercase tracking-[0.25em] text-[#C59B27]" htmlFor="admin-password">Password</label>
                <div className="mt-2 flex items-center gap-2 rounded-full border border-[#F2E1E6] bg-white px-4 focus-within:border-[#C95B7D]">
                    <Lock className="h-4 w-4 text-[#8C6A5D]" />
                    <input
                        id="admin-password"
                        data-testid="admin-password-input"
                        type="password"
                        autoFocus
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="h-12 w-full bg-transparent text-sm text-[#3D2318] outline-none"
                    />
                </div>
                {error && <p className="mt-3 text-sm text-[#b3261e]" data-testid="admin-login-error">{error}</p>}
                <button
                    type="submit"
                    disabled={busy}
                    data-testid="admin-login-submit"
                    className="group mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#C95B7D] px-6 py-3.5 text-sm font-semibold text-white hover:bg-[#b44a6b] disabled:opacity-60 transition-colors"
                >
                    {busy ? "Signing in…" : "Sign In"}
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </button>
            </form>
        </div>
    );
}
